import { topicItems } from '@/mocks/home';
import SectionHeading from './SectionHeading';

const iconTone = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-800',
};

export default function TopicSection() {
  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="分区导航"
          title="按板块找事件 · 六大分区持续归档"
          desc="每个分区都按事件为单位归档，不按帖子散落，进入即可看到该领域的时间线与后续处理。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {topicItems.map((topic) => (
            <a
              key={topic.name}
              href="#feed"
              className="group flex cursor-pointer items-start gap-4 rounded-lg border border-background-300 bg-background-100 p-5 transition-colors hover:border-primary-300 hover:bg-background-50"
            >
              <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg ${iconTone[topic.accent]}`}>
                <i className={`${topic.icon} text-2xl`} />
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">
                    {topic.name}
                  </h3>
                  <i className="ri-arrow-right-up-line text-lg text-foreground-400 transition-colors group-hover:text-primary-600" />
                </div>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{topic.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 rounded-full bg-background-200 px-2.5 py-0.5 text-[11px] font-semibold text-foreground-700">
                  <i className="ri-stack-line text-sm" />
                  {topic.count}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}